import { render, staticRenderFns } from "./reserve-order.vue?vue&type=template&id=24331da8"
import script from "./reserve-order.vue?vue&type=script&lang=js"
export * from "./reserve-order.vue?vue&type=script&lang=js"
import style0 from "./reserve-order.vue?vue&type=style&index=0&id=24331da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports